/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_F_Body1Inputs */

const vi_sitesettings_f_body1 = /** @type {(inputs: Sitesettings_F_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung`)
};

/**

* @param {Sitesettings_F_Body1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_f_body1 = /** @type {((inputs?: Sitesettings_F_Body1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_F_Body1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_f_body1(inputs)
});
export { sitesettings_f_body1 as "siteSettings_f_body" }